import { useQuery } from '@apollo/client';

import { CanUseEnrollTrustedDeviceDocument } from './graphql/canUseEnrollTrustedDevice.gql';

export const useEnrollTrustedDevice = () => {
  const { data } = useQuery(CanUseEnrollTrustedDeviceDocument);

  return data?.canUseEnrollTrustedDevice || false;
};
